import isEmpty from '../helpers/isEmpty'

function normalizeBodyTypeName(bodyType) {
  if (typeof bodyType === 'string') {
    return bodyType.trim().toLowerCase()
  }

  if (bodyType && typeof bodyType === 'object' && typeof bodyType.name === 'string') {
    return bodyType.name.trim().toLowerCase()
  }

  return ''
}
//--------------------------
// calc location hit points
//--------------------------
export default function calcLocationHPs({ body_type, siz, con, con_wounds = 0 }) {
  let locationHPs = {
    head: 0,
    arms: 0,
    chest: 0,
    abdomen: 0,
    legs: 0,
  }

  const normalizedBodyType = normalizeBodyTypeName(body_type)

  if (
    isEmpty(siz) ||
    isEmpty(con) ||
    siz === 0 ||
    con === 0 ||
    isEmpty(normalizedBodyType) ||
    normalizedBodyType !== 'humanoid'
  )
    return locationHPs

  const effectiveCon = con + (Number(con_wounds) || 0)
  const tot = siz + effectiveCon

  if (tot >= 1 && tot <= 5) {
    locationHPs.head = 1
    locationHPs.arms = 1
    locationHPs.chest = 3
    locationHPs.abdomen = 2
    locationHPs.legs = 1
  } else if (tot >= 6 && tot <= 10) {
    locationHPs.head = 2
    locationHPs.arms = 1
    locationHPs.chest = 4
    locationHPs.abdomen = 3
    locationHPs.legs = 2
  } else if (tot >= 11 && tot <= 15) {
    locationHPs.head = 3
    locationHPs.arms = 2
    locationHPs.chest = 5
    locationHPs.abdomen = 4
    locationHPs.legs = 3
  } else if (tot >= 16 && tot <= 20) {
    locationHPs.head = 4
    locationHPs.arms = 3
    locationHPs.chest = 6
    locationHPs.abdomen = 5
    locationHPs.legs = 4
  } else if (tot >= 21 && tot <= 25) {
    locationHPs.head = 5
    locationHPs.arms = 4
    locationHPs.chest = 7
    locationHPs.abdomen = 6
    locationHPs.legs = 5
  } else if (tot >= 26 && tot <= 30) {
    locationHPs.head = 6
    locationHPs.arms = 5
    locationHPs.chest = 8
    locationHPs.abdomen = 7
    locationHPs.legs = 6
  } else if (tot >= 31 && tot <= 35) {
    locationHPs.head = 7
    locationHPs.arms = 6
    locationHPs.chest = 9
    locationHPs.abdomen = 8
    locationHPs.legs = 7
  } else if (tot >= 36) {
    locationHPs.head = 8
    locationHPs.arms = 7
    locationHPs.chest = 10
    locationHPs.abdomen = 9
    locationHPs.legs = 8
  }

  if (tot >= 45) {
    const bonus = Math.floor((tot - 40) / 5)
    locationHPs.head += bonus
    locationHPs.arms += bonus
    locationHPs.chest += bonus
    locationHPs.abdomen += bonus
    locationHPs.legs += bonus
  }

  return locationHPs
}
